
import { getFileUploadURL } from '@/utils/constant'
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { AppModule } from '@/store/modules/app'
import { getWebpFileByImageFile } from '@/utils/file'
import { uploadFile } from '@/api/download'
import OSS from 'ali-oss'
import { getOssPlicy } from '@/api/user'

@Component({
  name: 'logoUploader'
})
export default class extends Vue {
  @Prop({ required: true }) private logo!: string
  private apiUrl: string = getFileUploadURL() + '/upload-file'
  private ossParams: any = {}
  private uploadDir: any = ''
  private fileList: any = {
    url: ''
  }
  private file: any
  get language() {
    return AppModule.language
  }

  private handleAvatarSuccess(res, file) {
    this.$emit('uploadOk', res.file_path)
  }

  private async beforeAvatarUpload(file) {
    this.file = await getWebpFileByImageFile(file)
    const isLt5M = this.file.size / 1024 / 1024 < 5
    if (!isLt5M) {
      this.$message.error('File size should not exceed 5MB!')
    }

    return isLt5M
  }
  private uploadFn() {
    const form = new FormData()
    form.append('file', this.file, this.file.name)
    // uploadFile(form).then((res: any) => {
    const random_name = this.randomFileName(this.file, 6)
    const oss = new OSS(this.ossParams)
    oss
      .put(random_name, this.file)
      .then((res: any) => {
        this.fileList.url = res.res.requestUrls[0]
        this.$emit('uploadOk', this.fileList.url)
      })
      .catch(e => {
        console.log('失败了')
      })
    // this.$emit('uploadOk', res.file_path)
    // })
  }

  // 随机生成文件名
  private randomFileName(file, len) {
    len = len || 32
    let chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz12345678'
    let maxPos = chars.length
    let pwd = ''
    for (let i = 0; i < len; i++) {
      pwd += chars.charAt(Math.floor(Math.random() * maxPos))
    }
    let fileName =
      this.uploadDir +
      pwd +
      '_' +
      new Date().getTime() +
      '.' +
      file.name.split('.').pop()
    return fileName
  }

  // oss配置
  private async getOssPlict() {
    try {
      getOssPlicy().then((res: any) => {
        const {
          expiration,
          access_key_secret,
          access_key,
          sts_token,
          upload_dir,
          bucket,
          region
        } = res
        this.ossParams = {
          secure: true,
          region: region,
          bucket: bucket,
          accessKeyId: access_key,
          accessKeySecret: access_key_secret,
          stsToken: sts_token
        }
        this.uploadDir = upload_dir
      })
    } catch (e) {}
  }

  @Watch('logo', { deep: true, immediate: true })
  private watchLogo() {
    if (this.logo) {
      this.fileList.url = this.logo
    } else {
      this.fileList.url = ''
    }
  }

  mounted() {
    this.getOssPlict()
  }
}
